import { render, staticRenderFns } from "./PanelResumeEducations.vue?vue&type=template&id=d7154ad8&"
import script from "./PanelResumeEducations.vue?vue&type=script&lang=js&"
export * from "./PanelResumeEducations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports